//import { IListResource } from '../../httpClient/resources/Resource';
import * as queryString from 'query-string';

import { makeRestApiRequest, RestApiRequestConfig } from '~src/httpClient/RestApiService';
import { IPagedItemsParams } from '~src/httpClient/serverApi/types/IPage';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';
import { IOrderClause } from '~src/spacesPlatform/serverApi/types/IOrderClause';

import { IGroupSetInfo } from '../../models/IGroupSetInfo';
import { createBaseRestConfig } from '../GroupSetsServerApiHelper';


// Define a generic type for operators
type OperatorsType = {
    [key: string]: string;
};

export const Operators: OperatorsType = {
    equals: 'eq',
    in: 'in',
    case_insensitive_equals: 'cieq',
    like: 'like',
    matches: 'matches'
};

export const SupportedFields = {
    NAME: 'name',
};

export const ResultLevels = {
    MEMBERS: 'members',
};

// Function to build the filter string
function buildFilterString(filterParams: FilterParam) {
    if (!filterParams || !filterParams.clauses.length) {
        return '';
    }

    const filterStrings = filterParams.clauses.map(param => {
        const operator = Operators[param.operator];
        const fieldValue = param.value;
        const fieldName = SupportedFields[param.fieldName];

        if (operator && fieldValue) {
            if (operator === Operators.matches) {
                return `${fieldValue}:${operator}`;
            }
        }

        if (operator && fieldValue && fieldName) {
            if (operator === Operators.in && Array.isArray(fieldValue)) {
                const values = fieldValue.join(',');
                return `${fieldName}:${operator}:[${values}]`;
            } else {
                return `${fieldName}:${operator}:${fieldValue}`;
            }
        }
        return '';
    });
    return `&filter=${filterStrings.join(',')}`;
}

function buildSortString(clauses: IOrderClause[]) {
    if (!clauses || !clauses.length) {
        return '';
    }
    const sortStrings = clauses.map(clause => {
        return `${clause.field + ':' + (clause.ascending ? 'asc' : 'desc')}`;
    });
    return `&sort=${sortStrings.join(',')}`;
}

export interface FilterClause {
    operator: keyof typeof Operators;
    fieldName?: keyof typeof SupportedFields;
    value: string | string[];
}
export interface FilterParam {
    operator: keyof typeof Operators;
    clauses: FilterClause[];
}

export enum ResultLevel {
    MEMBERS = 'members',// Fetch groups
    LOCAL = 'local' //Fetch localId (primarykey)
}

export interface IGetAllGroupSetsParams extends IPagedItemsParams {
    filter?: FilterParam;
    order?: IOrderClause[];
    resultLevel?: ResultLevel;
}

export interface IGroupSetResultInfo {
    groupSet: IGroupSetInfo[];
}

export interface IGetGroupSetDetailsResult extends IResult {
    groupSets?: IGroupSetResultInfo;
}

export async function getAllGroupSets(params: IGetAllGroupSetsParams = {}): Promise<IGetGroupSetDetailsResult> {
    const filterString = buildFilterString(params.filter);
    const sortString = buildSortString(params.order);

    const resultLevelString = params.resultLevel ? `resultlevel=${params.resultLevel}` : 'resultlevel=members';

    const config: RestApiRequestConfig<{}, {}> = {
        ...createBaseRestConfig(),
        httpMethod: 'GET',
        endpoint: `groupsets`,
        queryParams: queryString.parse(`${resultLevelString}${filterString}${sortString}`)
    };

    let response = makeRestApiRequest<{}, any, {}>(config);
    return response.then((result: any) => {
        return result;
    }, (error) => Promise.reject(error));
}